(function () {

    'use strict';

    angular.module('asys')
        .component('asysBlockTarifdetails', {
            bindings: {
                tarifdetailsData: '@abtData',
                tarifdetailsTextProp: '@?abtTarifdetailsTextProp',
                tarifdetailsFilter: '@?abtTarifdetailsFilter',
                tarifdetailsTemplateData: '<?abtTarifdetailsTemplateData',
                avb: '@?abtAvb',
                tarifarten: '<abtTarifarten',
                baustein: '<abtBaustein',
                bausteinKeys: '<abtBausteinKeys',
                showTarifdetails: '<?abtShowTarifdetails',
                onTarifdetailsFiltered: '&?abtOnTarifdetailsFiltered',
                toggle: '&?abtToggle',
                options: '<abtOptions'
            },
            templateUrl: 'bloecke/tarifdetails/blockTarifdetails.html',
            controller: BlockTarifdetailsController,
            controllerAs: 'blockTarifdetailsVm'
        })
        .service('TarifdetailsService', TarifdetailsService);

    BlockTarifdetailsController.$inject = [
        '$scope',
        '$element',
        '$window',
        '$timeout',
        '$analytics',
        'lodash',
        'mediaQueries',
        'TarifdetailsService',
        'MiscUtilsService',
        'HtmlUtilsService',
        'TrackingUtilsService'
    ];
    function BlockTarifdetailsController($scope, $element, $window, $timeout, $analytics, _, mediaQueries, TarifdetailsService, MiscUtilsService, HtmlUtilsService, TrackingUtilsService) {
        var vm = this,
            tarifartMap = {
                p: 'plus',
                s: 'optimal',
                b: 'basis'
            },
            firstToggleBtn = $element.find('a');

        vm.isOpen = false;
        vm.tarifdetails = {};
        vm.tarifdetailsTarifarten = [];
        vm.optionalTarifdetailsSichtbar = {};

        vm.$onInit = onInit;
        vm.$onChanges = onChanges;
        vm.onToggle = onToggle;
        vm.getLabel = getLabel;
        vm.getText = getText;
        vm.getId = getId;
        vm.isZeileSichtbar = isZeileSichtbar;
        vm.getMainCls = getMainCls;
        vm.isOptionalTarifdetailsSichtbar = isOptionalTarifdetailsSichtbar;
        vm.onOpenTarifdetailsGroup = onOpenTarifdetailsGroup;
        vm.onCloseTarifdetailsGroup = onCloseTarifdetailsGroup;
        vm.onToggleOptionalTarifdetails = onToggleOptionalTarifdetails;

        $scope.$watch(function () {
            return vm.showTarifdetails;
        }, function (value) {
            if (_.isBoolean(value)) {
                _toggle(value);
            }
        });
        function _parseTarifarten() {
            var tarifartWert;

            vm.tarifdetailsTarifarten = [];

            _.forEach(_.compact(vm.tarifarten), function (tarifart) {
                tarifartWert = _.lowerCase(_.get(tarifart, 'wert'));

                tarifartWert = tarifartMap[tarifartWert] ? tarifartMap[tarifartWert] : tarifartWert;

                if (_.indexOf(vm.tarifdetailsTarifarten, tarifartWert) === -1) {
                    vm.tarifdetailsTarifarten.push(tarifartWert);
                }
            });

            vm.hasMehrereTarifarten = _.size(vm.tarifdetailsTarifarten) > 1;
        }
        function _toggle(open) {
            vm.isOpen = open;

            if (!firstToggleBtn[0]) {
                firstToggleBtn = $element.find('a');
            }

            if (firstToggleBtn[0] && _.isFunction(firstToggleBtn[0].focus)) {
                firstToggleBtn[0].focus();
            }
        }

        function onResize() {
            recalcGridLayout();
        }

        function recalcGridLayout() {
            if (mediaQueries.large()) {
                vm.gridLayoutCss.tarifartText = 'small-' + 12 / _.size(vm.tarifdetailsTarifarten);
            } else {
                vm.gridLayoutCss.tarifartText = 'small-12';
            }
            $scope.$digest();
        }

        function activate() {
            vm.otions = vm.options || {};
            vm.gridLayoutCss = vm.otions.grid || {};
            vm.textProp = vm.tarifdetailsTextProp || 'text';
            vm.bausteinKeys = vm.bausteinKeys ? _.flatten([vm.bausteinKeys]) : null;
            vm.tarifdetails = [];

            angular.element($window).bind('resize', onResize);

            if (vm.baustein) {
                vm.tarifartAktiv = tarifartMap[_.toLower(_.get(vm.baustein, 'tarifartModellierung.wert'))];
            }

            if (vm.tarifdetailsData) {
                TarifdetailsService.load(vm.tarifdetailsData).then(function (data) {
                    vm.tarifdetails = data || {};
                }).catch(function () {
                    vm.tarifdetails = [];
                }).finally(function () {
                    vm.filteredTarifdetails = vm.tarifdetails;

                    if (vm.bausteinKeys) {
                        _.each(vm.filteredTarifdetails, function (tarifdetail, idx) {
                            _.each(['data'], function (tarifdetailKey) {
                                vm.filteredTarifdetails[idx][tarifdetailKey] = _.filter(tarifdetail[tarifdetailKey], function (tarifdetailZeile) {
                                    return !_.has(tarifdetailZeile, 'bausteinKey') || _.some(tarifdetailZeile.bausteinKey, function (val) { return _.includes(vm.bausteinKeys, val); });
                                });
                            });
                        });
                    }

                    if (vm.tarifdetailsFilter) {
                        _.each(vm.filteredTarifdetails, function (tarifdetails) {
                            tarifdetails.data = _.filter(tarifdetails.data, function (tarifdetail) {
                                return isZeileSichtbar(tarifdetail);
                            });
                        });
                    }

                    _.each(vm.filteredTarifdetails, function (tarifdetails) {
                        var size = tarifdetails.size || 5;

                        if (size === -1) {
                            tarifdetails.permanent = tarifdetails.data;
                            tarifdetails.optional = [];
                        } else {
                            tarifdetails.permanent = _.slice(tarifdetails.data, 0, size);
                            tarifdetails.optional = _.slice(tarifdetails.data, size);
                        }
                    });

                    if (_.isFunction(vm.onTarifdetailsFiltered)) {
                        vm.onTarifdetailsFiltered({
                            tarifdetails: vm.filteredTarifdetails
                        });
                    }
                });
            }

            if (!vm.gridLayoutCss.columnLeft) {
                if (_.size(vm.tarifdetailsTarifarten) >= 2) {
                    vm.gridLayoutCss.columnLeft = 'small-12';
                } else {
                    vm.gridLayoutCss.columnLeft = 'small-12 medium-9';
                }
            }

            if (!vm.gridLayoutCss.columnRight) {
                if (_.size(vm.tarifdetailsTarifarten) >= 2) {
                    vm.gridLayoutCss.columnRight = 'small-12';
                } else {
                    vm.gridLayoutCss.columnRight = 'small-12 medium-3';
                }
            }

            if (mediaQueries.large()) {
                vm.gridLayoutCss.tarifartText = 'small-' + 12 / _.size(vm.tarifdetailsTarifarten);
            } else {
                vm.gridLayoutCss.tarifartText = 'small-12';
            }
        }

        function onInit() {
            vm.uuid = MiscUtilsService.guid();

            activate();
        }

        function onChanges(changes) {
            if (!_.isEqual(_.get(changes, 'tarifarten.currentValue'), _.get(changes, 'tarifarten.previousValue'))) {
                _parseTarifarten();
            }
            activate();
        }
        function onToggle() {
            _toggle(!vm.isOpen);

            if (_.isFunction(vm.toggle)) {
                vm.toggle({ open: vm.isOpen });
            }
        }
        function getText(tarifdetail, textProp) {
            return TarifdetailsService.getText(tarifdetail, (textProp || vm.textProp), vm.tarifdetailsFilter, vm.tarifdetailsTemplateData, vm.avb);
        }

        function getLabel(tarifdetail) {
            return tarifdetail.label;
        }

        function getId() {
            return MiscUtilsService.guid();
        }
        function isZeileSichtbar(tarifdetail) {
            return (
                (
                    !_.isObject(_.get(tarifdetail, 'tarifarten')) &&
                    !_.isEmpty(getText(tarifdetail))
                ) || (
                    _.isObject(_.get(tarifdetail, 'tarifarten')) &&
                    _.some(vm.tarifdetailsTarifarten, function (tarifart) {
                        return !_.isEmpty(getText(tarifdetail, 'tarifarten.' + tarifart));
                    })
                )
            );
        }

        function getMainCls() {
            var cls = ['ipjs-no-copy-check'];

            if (vm.hasMehrereTarifarten) {
                cls.push('mehrere-tarifarten');
                cls.push('tarifarten-' + _.size(vm.tarifdetailsTarifarten));
            }

            if (_.get(vm.gridLayoutCss, 'tarifdetailsMainCls')) {
                cls.push(vm.gridLayoutCss.tarifdetailsMainCls);
            }

            if (vm.tarifdetailsData) {
                cls.push(vm.tarifdetailsData);
            }

            return cls.join(' ');
        }

        function isOptionalTarifdetailsSichtbar(tarifdetailGroupId) {
            return !!vm.optionalTarifdetailsSichtbar[tarifdetailGroupId];
        }

        function onOpenTarifdetailsGroup(tarifdetailGroup) {
            tarifdetailGroup = tarifdetailGroup || {};
            if (tarifdetailGroup.open && vm.optionalTarifdetailsSichtbar[tarifdetailGroup.id] === undefined) {
                TrackingUtilsService.trackDefaultEvent('accordion', 'wgv', [{
                    name: tarifdetailGroup.id,
                    value: 'open',
                    state: 'default'
                }]);
            } else {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: tarifdetailGroup.id,
                    value: 'open'
                });
            }

            vm.optionalTarifdetailsSichtbar[tarifdetailGroup.id] = false;
        }

        function onCloseTarifdetailsGroup(tarifdetailGroup) {
            tarifdetailGroup = tarifdetailGroup || {};

            if (vm.optionalTarifdetailsSichtbar[tarifdetailGroup.id] !== undefined) {
                $analytics.eventTrack('accordion', {
                    trackingProvider: 'wgv',
                    target: tarifdetailGroup.id,
                    value: 'close'
                });
            }
        }

        function onToggleOptionalTarifdetails(tarifdetailGroupId, show) {
            vm.optionalTarifdetailsSichtbar[tarifdetailGroupId] = show;

            $analytics.eventTrack('accordion', {
                trackingProvider: 'wgv',
                target: tarifdetailGroupId + '_optional',
                value: show ? 'open' : 'close'
            });

            if (!show) {
                $timeout(function () {
                    HtmlUtilsService.scrollIntoView($element[0].querySelector('#' + tarifdetailGroupId + '_' + vm.uuid), {
                        behavior: 'smooth',
                        block: 'center'
                    });
                });
            }
        }
    }

    TarifdetailsService.$inject =[
        '$http',
        '$q',
        'AppConfig',
        'lodash',
        'FormatUtilsService',
        'MiscUtilsService'
    ];

    function TarifdetailsService($http, $q, AppConfig, _, FormatUtilsService, MiscUtilsService) {
        var that = this,
            serviceUrl = (AppConfig.APP.releaseDir ? AppConfig.APP.releaseDir + '/' : '') + 'data/tarifdetails{0}.json';

        that.load = load;
        that.preload = preload;
        that.getText = getText;
        that.getFilterConditionKey = getFilterConditionKey;
        function load(tarifdetails) {
            if (!tarifdetails) {
                return $q.resolve({});
            }

            return $http.get(FormatUtilsService.replace(serviceUrl, _.upperFirst(tarifdetails)), {
                cache: true,
                httpErrorsIgnore: true
            }).then(function (response) {
                return response.data || {};
            }).catch(function () {
                return {};
            });
        }
        function preload(tarifdetails) {
            var preloadTarifdetails = [];

            if (_.isString(tarifdetails)) {
                preloadTarifdetails.push(tarifdetails);
            } else if (_.isArray(tarifdetails)) {
                preloadTarifdetails = tarifdetails;
            }

            _.forEach(preloadTarifdetails, function (val) {
                load(val);
            });
        }
        function getText(tarifdetail, textProp, filter, tarifdetailsTemplateData, avb) {
            var text,
                retValue,
                filterConditionKey,
                zeileFilter = _.get(tarifdetail, 'filter'),
                zeileFilterAvb = _.get(tarifdetail, 'avb');

            if (zeileFilterAvb) {
                if (!getFilterConditionKey(zeileFilterAvb, avb)) {
                    return;
                }
            }

            if (zeileFilter) {
                if (_.startsWith(zeileFilter, '<%=') && tarifdetailsTemplateData) {
                    zeileFilter = _.template(zeileFilter, { variable: 'data' })(tarifdetailsTemplateData);
                }

                if (!getFilterConditionKey(zeileFilter, filter)) {
                    return;
                }
            }

            text = _.get(tarifdetail, textProp, '');

            if (_.isObject(text)) {
                _.forEach(text, function (val, key) {
                    filterConditionKey = getFilterConditionKey(key, filter);
                    retValue = _.get(text, filterConditionKey);

                    if (retValue) {
                        return false;
                    }
                });
            } else {
                retValue = text;
            }

            if (retValue) {
                retValue = retValue.replace(/✓/g,'<i class="icon included" title="Versichert" aria-label="Versichert"></i><span class="sr-only">Versichert</span>').replace(/－/g,'<i class="icon not-included" title="Nicht versichert" aria-label="Nicht versichert">－</i><span class="sr-only">Nicht versichert</span>');
            }

            return retValue;
        }
        function getFilterConditionKey(filterCondition, filterVal) {
            filterCondition = filterCondition || '';

            if (MiscUtilsService.isEmpty(filterVal)) {
                return null;
            }

            if (MiscUtilsService.checkFilterCondition(filterCondition, filterVal)) {
                return filterCondition;
            }

            return null;
        }
    }

})();
